import React, { useEffect, useMemo, useState } from "react";
import UserSection from "../../Services/User/UserLogin";
import { Link, useLocation } from "react-router-dom";
import UserTopbar from "../UserTopbar";
import animationData from "../../animations/loader_animation0.json";
import Lottie from "lottie-react";
import { useNavigate } from "react-router-dom";
import { FaDownload, FaSearch } from "react-icons/fa";
import { FaFilePdf } from "react-icons/fa";
import DownloadSummary from "./DownloadSummary";
import ViewProjects from "./ViewProjects";
import Loader from "../utils/Loader";
import PreviewIcon from "@mui/icons-material/Preview";
import DownloadIcon from "@mui/icons-material/Download";
import { useOutletContext } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  IconButton,
  TablePagination,
  Box,
  Autocomplete,
  Checkbox,
  Paper,
  Tooltip,
  Avatar,
  Typography,
  CircularProgress,
  Skeleton,
} from "@mui/material";
import drive from "../../../src/SliderImage/drive.png";
import excelImg from "../../../src/SliderImage/excel.png";
import { Select as MuiSelect } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";

import FileCopyIcon from "@mui/icons-material/FileCopy";
// Importing XLSX for Excel download functionality
import * as XLSX from "xlsx";
import PDF from "./PDF";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllPdfImages,
} from "../../redux/slices/pdfSlice";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { MenuItem, FormControl, InputLabel } from "@mui/material";
import CataloguePDF from "./CataloguePDF";
import { fetchSummary } from "../../redux/slices/summarySlice";
import { ArrowDropDownCircleOutlined, CalendarMonth, CalendarToday, PeopleAlt, PictureAsPdfSharp, Settings } from "@mui/icons-material";
import { handleApiError } from "../../Helpers/handleApiError ";
import MultiSelectWithCheckbox from "../utils/MultiSelectWithCheckbox";
import { fetchUserClientOption, fetchUserOption } from "../../redux/slices/clientSlice";
import UserService from "../../Services/UserList";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import Swal from "sweetalert2";
import ShareQuoteDialog from "../utils/ShareQuoteDialog";
import { usePdf } from "../context/pdfContext";
import { EditIcon } from "lucide-react";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";

const Summary = () => {
  const { jsPDF } = require("jspdf");
  const navigate = useNavigate();
  const location = useLocation();
  const aiDownloadMessageIdRef = React.useRef(null);
  const [sectionArr, setSectionArr] = useState([]);
  const [projectId, setprojectId] = useState();
  const [pdfId, setpdfId] = useState();
  const [projectDatas, setprojectData] = useState();
  const [sectionTotal, setSectionTotal] = useState(0);
  const [showComponent, setshowComponent] = useState(false);
  const [showPdfComponent, setshowPdfComponent] = useState(false);
  const [pdfloading, setPdfLoading] = useState(false);
  const [excelloading, setExcelLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisable] = useState(false);
  const [dataFromDownloadSummary, setDataFromDownloadSummary] = useState("");
  const [searchQuery, setSearchQuery] = useState(() => {
    const pid = location.state?.project_id ?? "";
    if (pid) window.history.replaceState({}, '');
    return pid;
  });

  const { isSidebarOpen } = useOutletContext();
  const { summaryData, sumStatus, count } = useSelector(state => state.summary)
  const counts = count || 0;
  const [selectedClients, setSelectedClients] = useState([]);
  const [channelOpt, setChannelOpt] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const getDefaultFinancialMonths = () => {
    const currentMonthNum = new Date().getMonth() + 1; // 1-12
    let months = [];
    if (currentMonthNum >= 4) {
      for (let i = 4; i <= currentMonthNum; i++) {
        months.push(String(i).padStart(2, "0"));
      }
    } else {
      for (let i = 4; i <= 12; i++) {
        months.push(String(i).padStart(2, "0"));
      }
      for (let i = 1; i <= currentMonthNum; i++) {
        months.push(String(i).padStart(2, "0"));
      }
    }
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return months.map(m => ({ value: m, label: monthNames[parseInt(m) - 1] }));
  };

  const current_year = String(new Date().getFullYear());
  const [month, setMonth] = useState(getDefaultFinancialMonths());
  const [year, setYear] = useState([{ value: current_year, label: `${current_year}-${parseInt(current_year) + 1}` }]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { clientsOption, userOption } = useSelector((state) => state.client);
  const userId = localStorage.getItem('anonymous_id')
  const { downloadPdf } = usePdf();
  const handleDataFromDownloadSummary = (data) => {
    setDataFromDownloadSummary(data);
    setprojectId("");
  };

  useEffect(() => {
    dispatch(fetchUserClientOption());
    dispatch(fetchUserOption());
    UserService.GetChannels().then(response => {
      if (response && response.data) {
        setChannelOpt(response.data.map(ch => ({
          value: ch.id,
          label: ch.channel_name
        })));
      }
    }).catch(console.error);
  }, [])

  useEffect(() => {
    if (
      dataFromDownloadSummary == "downloaded" ||
      dataFromDownloadSummary == "failed"
    ) {
      setExcelLoading(false);
      if (aiDownloadMessageIdRef.current) {
        window.dispatchEvent(new CustomEvent('ai-download-complete', {
          detail: {
            messageId: aiDownloadMessageIdRef.current,
            success: dataFromDownloadSummary === "downloaded",
            message: dataFromDownloadSummary === "failed" ? "Failed to generate Excel." : "Download completed successfully!"
          }
        }));
        aiDownloadMessageIdRef.current = null;
      }
    }
  }, [dataFromDownloadSummary]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDataFromDownloadSummary("");
      setprojectId("");
    }, 2000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [projectId, dataFromDownloadSummary]);

  useEffect(() => {
    const handleAiDownload = async (e) => {
      const { format, targetType, targetValue, messageId } = e.detail;
      let idToDownload = null;

      if (targetType === 'id') {
        idToDownload = targetValue;
      } else if (targetType === 'srno') {
        const srno = parseInt(targetValue, 10);
        if (!isNaN(srno) && summaryData) {
          const index = srno - 1;
          if (index >= 0 && index < summaryData.length) {
            idToDownload = summaryData[index].project_id;
          }
        }
      }

      if (idToDownload) {
        try {
          if (format === 'excel') {
            downloadexcel(idToDownload);
            setExcelLoading(true);
            aiDownloadMessageIdRef.current = messageId;
          } else {
            setPdfLoading(true);
            await downloadPdf(idToDownload, `${Apiurl}user/downloadPdf`);
            setPdfLoading(false);
            window.dispatchEvent(new CustomEvent('ai-download-complete', {
              detail: { messageId, success: true }
            }));
          }
        } catch (error) {
          window.dispatchEvent(new CustomEvent('ai-download-complete', {
            detail: { messageId, success: false, message: "Download failed." }
          }));
          setPdfLoading(false);
          setExcelLoading(false);
        }
      } else {
        window.dispatchEvent(new CustomEvent('ai-download-complete', {
          detail: { messageId, success: false, message: "Could not find quotation." }
        }));
      }
    };

    window.addEventListener('ai-download-quotation', handleAiDownload);
    return () => window.removeEventListener('ai-download-quotation', handleAiDownload);
  }, [summaryData, downloadPdf]);

  useEffect(() => {
    dispatch(fetchSummary({
      search: searchQuery, page, rowsPerPage, month: month?.map(m => m.value) || [], year: year?.map(y => y.value) || [], client: selectedClients?.map((u) => u.value), channel: selectedChannels?.map((u) => u.value) || []
    }));
  }, [searchQuery, page, rowsPerPage, month, year, selectedClients, selectedChannels]);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (showComponent) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, []);

  const [loadingId, setLoadingId] = useState(null);

  const editProject = async (row, url) => {
    try {
      setLoadingId(row.id);
      const token = localStorage.getItem("u_token");

      const response = await axios.get(
        `${Apiurl}project/summary/project/${row.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const selectionDetails = response.data?.data || [];
      const quoteDetails = {
        ...(response.data?.client ?? {}),
        gstType: response.data?.client?.gst != 0 ? 'INC' : 'EXC'
      };

      navigate(
        `${url}/${row.client_id}/${encodeURIComponent(row.client_name)}/${row.id}`,
        { state: { selectionDetails, quoteDetails } }
      );

    } catch (error) {
      console.error("Failed to fetch project summary:", error);
    } finally {
      setLoadingId(null); // Clear loading state
    }
  };

  const downloadexcel = async (id) => {
    try {
      setprojectId(id);
    } catch (error) {
      console.log(error);
    }
  };

  const downloadpdf = async (id) => {
    try {
      navigate(`/user/viewProjects?project_id=${id}`);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const downloadExcel = () => {
    const refinedData = summaryData?.map((item, index) => ({
      "S.No.": index + 1,
      Client_Id: item.client_id,
      Project_Id: item.project_id,
      Channel: item.user_channel || "N/A",
      Modiified_By: (() => {
        const user = userOption?.find((u) => u.id == item?.updated_user_id);

        if (!item?.updated_user_id || !user) {
          return (
            <Typography variant="caption" sx={{ color: "#94a3b8" }}>
              No updates
            </Typography>
          );
        }

        return `${user.name} ${user.last_name || ""}`.trim();
      })(),
      Valid_Upto: new Date(item.valid_date).toLocaleDateString("en-GB"),
      Created_At: new Date(item.created_at).toLocaleDateString("en-GB"),
      Client_Name: item.client_name,
      Phone: item.phone,
    }));

    const ws = XLSX.utils.json_to_sheet(refinedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Project Data");
    XLSX.writeFile(wb, "Project_Summary.xlsx");
  };

  const dispatch = useDispatch();
  const {
    coverImages,
    summaryImages,
    themeImages,
    lastImages,
    techImages,
    communicationImages,
    getStatus,
  } = useSelector((state) => state.pdfImages);

  useEffect(() => {
    if (coverImages.length === 0 && summaryImages.length === 0) {
      dispatch(fetchAllPdfImages());
    }
  }, []);

  const [status, setStatus] = useState("");

  const handleChange = async (id, value) => {
    setStatus(value);
    try {
      setLoading(true);
      const response = await UserSection.updatesummary({ id, value });
      if (response.status) {
        dispatch(fetchSummary({
          search: searchQuery, page, rowsPerPage, month: month?.map(m => m.value) || [], year: year?.map(y => y.value) || [], client: selectedClients?.map((u) => u.value), channel: selectedChannels?.map((u) => u.value) || []
        }));
      }
      setLoading(false);
    } catch (error) { }
  };

  const monthOption = [
    { label: "January", value: "01" },
    { label: "February", value: "02" },
    { label: "March", value: "03" },
    { label: "April", value: "04" },
    { label: "May", value: "05" },
    { label: "June", value: "06" },
    { label: "July", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" }
  ];

  const currentYear = new Date().getFullYear();
  const yearOptions = [];
  for (let y = 2024; y <= currentYear; y++) {
    yearOptions.push({ label: `${y}-${y + 1}`, value: y.toString() });
  }

  const clientOpt = clientsOption
    ? clientsOption.map((item) => ({
      value: item.id,
      label: `${item.client_name.toUpperCase()} - ${item.id}`,
    }))
    : [];

  const [selectedRows, setSelectedRows] = useState([]);
  const [isShareOpen, setIsShareOpen] = useState(false);

  const handleSelectRow = (row) => {
    setSelectedRows((prev) => {
      const isSelected = prev.find((item) => item.id === row.id);
      if (isSelected) {
        return prev.filter((item) => item.id !== row.id);
      } else {
        return [
          ...prev,
          {
            id: row.id,
            project_id: row.project_id,
            shared: row.shared,
          },
        ];
      }
    });
  };

  const navigateToPdfSettings = (id) => {
    window.open(`/user/pdf-settings?id=${id}`, '_blank');
  };

  const handleShareSubmit = async (payload) => {
    setLoading(true);
    try {
      const requests = payload.map((data) =>
        axios.post(
          `${Apiurl}admin/share-quotations`,
          {
            project_ids: data.project_ids,
            user_ids: data.user_ids,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("u_token")}`,
            },
          }
        )
      );

      await Promise.all(requests);

      dispatch(fetchSummary({
        search: searchQuery, page, rowsPerPage, month: month?.map(m => m.value) || [], year: year?.map(y => y.value) || [], client: selectedClients?.map((u) => u.value), channel: selectedChannels?.map((u) => u.value) || []
      }));

      Swal.fire("Success", "All quotation share settings updated!", "success");
      setSelectedRows([]);
      setIsShareOpen(false);
    } catch (error) {
      Swal.fire("Error", "Failed to process", error);
    } finally {
      setLoading(false);
    }
  };

  const userOpt = useMemo(() => {
    return userOption?.map((user) => ({
      value: user.id,
      label: `${user.name} ${user.last_name} (${user.emp_code})`,
    })) || [];
  }, [userOption]);

  return (
    <>
      <UserTopbar heading={`Quotation Summary`} sidebar={isSidebarOpen} />
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar={true}
      />
      <ShareQuoteDialog
        open={isShareOpen}
        onClose={() => setIsShareOpen(false)}
        users={userOpt}
        selectedQuotes={selectedRows}
        onShare={handleShareSubmit}
      />
      {(loading) ? (
        <div className="w-full mt-2 bg-white/60 backdrop-blur-md rounded-2xl shadow-lg border border-white/50 overflow-hidden">
          {/* Header Skeleton */}
          <div className="bg-white/50 p-4 flex justify-between items-center border-b border-white/50">
            <div className="h-10 w-[27rem] bg-gray-200 rounded-full animate-pulse"></div>
            <div className="flex gap-4">
              <div className="h-10 w-24 bg-gray-200 rounded-full animate-pulse"></div>
              <div className="h-10 w-32 bg-gray-200 rounded-full animate-pulse"></div>
            </div>
          </div>
          {/* Table Body Skeleton */}
          <div className="p-0">
            {/* Table Header Row */}
            <div className="flex gap-4 p-4 bg-white/40 border-b border-white/50">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(i => (
                <div key={i} className="h-4 bg-gray-200 rounded animate-pulse flex-1"></div>
              ))}
            </div>
            {/* Table Rows */}
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((row) => (
              <div key={row} className="flex gap-4 p-4 border-b border-white/30 items-center">
                {[1, 2, 3, 4, 5, 6, 7].map(col => (
                  <div key={col} className="h-6 bg-white/60 rounded animate-pulse flex-1"></div>
                ))}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="bg-white/60 backdrop-blur-md rounded-2xl shadow-lg border border-white mt-4 overflow-hidden">
          <Box
            className="bg-white/50 p-3 sm:p-4 border-b border-white/50"
            sx={{
              display: "flex",
              flexWrap: "wrap",          // lets items drop to the next line
              alignItems: "center",
              gap: { xs: 1.5, md: 2 },   // 12px on mobile, 16px on desktop
            }}
          >
            {/* Search: full width on mobile, flexible on desktop (no fixed 27rem) */}
            <div className="relative w-full md:w-auto md:flex-1 md:min-w-[16rem] md:max-w-[27rem]">
              <input
                type="text"
                value={searchQuery}
                onChange={handleSearchChange}
                placeholder="Search by Project-Id Client-Id Client-Name..."
                className="pl-10 pr-4 py-2.5 w-full border border-gray-300 rounded-full text-gray-700 bg-white/80 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#ff7b00]/50 focus:border-[#ff7b00] transition-all shadow-sm"
              />
              <span className="absolute inset-y-0 left-0 flex items-center pl-4">
                <FaSearch className="text-gray-400" />
              </span>
            </div>

            {/* Filters: each one wrapped so it can shrink/grow */}
            <div className="w-full sm:w-auto sm:min-w-[11rem] sm:flex-1 md:flex-none">
              <MultiSelectWithCheckbox
                options={clientOpt}
                value={selectedClients}
                onChange={setSelectedClients}
                placeholder="Select client"
                labelKey="client selected"
                width={220}
              />
            </div>

            <div className="w-full sm:w-auto sm:min-w-[11rem] sm:flex-1 md:flex-none">
              <MultiSelectWithCheckbox
                options={monthOption}
                value={month}
                onChange={setMonth}
                placeholder="Select Month"
                labelKey="month selected"
                sort={false}
                width={185}
              />
            </div>

            <div className="w-full sm:w-auto sm:min-w-[11rem] sm:flex-1 md:flex-none">
              <MultiSelectWithCheckbox
                options={yearOptions}
                value={year}
                onChange={setYear}
                placeholder="Select Year"
                labelKey="year selected"
                width={170}
              />
            </div>

            {/* Actions: Share + Excel + Drive stay together, never squashed */}
            <div className="flex items-center gap-3 shrink-0 w-full sm:w-auto sm:ml-auto justify-between sm:justify-end">
              <Button
                variant="contained"
                startIcon={<PeopleAlt />}
                onClick={() => setIsShareOpen(true)}
                disabled={selectedRows.length === 0}
                sx={{
                  textTransform: "none",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                  bgcolor: "#673ab7",
                  "&:hover": { bgcolor: "#512da8" },
                }}
              >
                Share{selectedRows.length > 0 ? ` (${selectedRows.length})` : ""}
              </Button>

              <div className="flex items-center gap-3 shrink-0">
                <button type="button" onClick={downloadExcel} aria-label="Download Excel">
                  <img
                    src={excelImg}
                    alt="Excel"
                    className="w-9 sm:w-11 h-auto transition-transform hover:scale-110"
                  />
                </button>

                <a href="https://drive.google.com/" target="_blank" rel="noopener noreferrer" aria-label="Open Google Drive">
                  <img
                    src={drive}
                    alt="Google Drive"
                    className="w-9 sm:w-11 h-auto transition-transform hover:scale-110"
                  />
                </a>
              </div>
            </div>
          </Box>

          <TableContainer sx={{ minHeight: "calc(100vh - 250px)", maxHeight: "calc(100vh - 250px)" }}>
            <Table stickyHeader>
              {/* Table Header */}
              <TableHead>
                <TableRow>
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                  </TableCell>
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Sr.No
                  </TableCell>
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Excel / PDF
                  </TableCell>
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Preview
                  </TableCell>
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Quotation ID
                  </TableCell>
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Client ID
                  </TableCell>
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Client Name
                  </TableCell>
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Currency
                  </TableCell>
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    WhatsApp
                  </TableCell>

                  {/* <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Channel
                  </TableCell> */}
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Created By
                  </TableCell>
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Modified By
                  </TableCell>
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Shared With
                  </TableCell>
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Transferred From
                  </TableCell>

                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Created At
                  </TableCell>
                  {/* <TableCell
                   className="bg-white/40 border-b border-white/50"
                    style={{
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >Assign To</TableCell> */}
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Modified At
                  </TableCell>

                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Valid Upto
                  </TableCell>
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Stage
                  </TableCell>
                  <TableCell
                    className="bg-white/40 border-b border-white/50"
                    style={{
                      whiteSpace: "nowrap",
                      color: "#1e293b",
                      fontWeight: "bold",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              {/* Table Body */}
              <TableBody sx={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }}>
                {sumStatus === "pending" ? (
                  Array.from(new Array(rowsPerPage)).map((_, index) => (
                    <TableRow key={`skeleton-${index}`}>
                      <TableCell><Skeleton variant="rectangular" width={20} height={20} /></TableCell>
                      <TableCell><Skeleton variant="text" width={30} /></TableCell>
                      <TableCell><Skeleton variant="rectangular" width={100} height={30} /></TableCell>
                      <TableCell><Skeleton variant="circular" width={24} height={24} /></TableCell>
                      <TableCell><Skeleton variant="text" width={80} /></TableCell>
                      <TableCell><Skeleton variant="text" width={60} /></TableCell>
                      <TableCell><Skeleton variant="text" width={120} /></TableCell>
                      <TableCell><Skeleton variant="circular" width={24} height={24} /></TableCell>
                      <TableCell><Skeleton variant="text" width={80} /></TableCell>
                      <TableCell><Skeleton variant="text" width={80} /></TableCell>
                      <TableCell><Skeleton variant="text" width={80} /></TableCell>
                      <TableCell><Skeleton variant="text" width={80} /></TableCell>
                      <TableCell><Skeleton variant="text" width={80} /></TableCell>
                      <TableCell><Skeleton variant="text" width={80} /></TableCell>
                      <TableCell><Skeleton variant="text" width={80} /></TableCell>
                      <TableCell><Skeleton variant="text" width={80} /></TableCell>
                      <TableCell><Skeleton variant="text" width={60} /></TableCell>
                      <TableCell><Skeleton variant="rectangular" width={24} height={24} /></TableCell>
                    </TableRow>
                  ))
                ) : (
                  summaryData?.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell>
                        <Checkbox
                          checked={selectedRows.some(
                            (item) => item.id == row.id
                          )}
                          onChange={() =>
                            handleSelectRow({
                              id: row.id,
                              project_id: row.project_id,
                              shared: row.shared,
                            })
                          }
                          disabled={userId != row?.user_id}
                        />
                      </TableCell>
                      <TableCell >{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>
                        <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-lg p-1 w-fit shadow-sm">
                          {excelloading && <Loader />}

                          {/* 1. EXCEL SECTION */}
                          <Tooltip title="Download Excel" arrow>
                            <IconButton
                              size="medium"
                              disabled={excelloading}
                              onClick={() => {
                                downloadexcel(row.project_id);
                                setExcelLoading(true);
                              }}
                              className="hover:bg-green-100/50 rounded-md transition-all"
                            >
                              <FileCopyIcon className="text-green-600" style={{ fontSize: '20px' }} />
                            </IconButton>
                          </Tooltip>

                          <div className="w-[1px] h-5 bg-gray-300 mx-0.5" />

                          {/* 2. PDF & SETTINGS GROUP (Visual Pair) */}
                          <div className="flex items-center bg-white border border-gray-200 rounded-md p-0.5 gap-0.5 shadow-inner">
                            <Tooltip title="Download PDF" arrow>

                              <IconButton
                                size="medium"
                                onClick={async () => {
                                  downloadPdf(row.project_id, `${Apiurl}user/downloadPdf`);
                                  try {
                                    const token = localStorage.getItem("u_token");

                                    await axios.post(
                                      `${Apiurl}project/download-status/${row.project_id}`,
                                      { pdfCount: 1 },
                                      {
                                        headers: {
                                          Authorization: `Bearer ${token}`,
                                        },
                                      }
                                    );
                                  } catch (statusError) {
                                    console.error("Failed to update download status", statusError);
                                  }

                                }}
                                className="hover:bg-red-50 rounded-sm transition-all"
                              >
                                <PictureAsPdfIcon className="text-red-600" style={{ fontSize: '20px' }} />
                              </IconButton>
                            </Tooltip>

                            <div className="w-[1px] h-3 bg-gray-200" />
                            <Tooltip title="Manage layout and content of PDF" arrow>
                              <IconButton
                                size="medium"
                                onClick={() => navigateToPdfSettings(row.project_id)}
                                className="hover:bg-gray-100 rounded-sm transition-all"
                              >
                                <Settings className="text-gray-500" style={{ fontSize: '20px' }} />
                              </IconButton>
                            </Tooltip>
                          </div>

                          <div className="w-[1px] h-5 bg-gray-300 mx-0.5" />

                          {/* 3. CATALOGUE (Independent) */}
                          <Tooltip title="Download Catalogue" arrow>
                            <IconButton
                              size="medium"
                              onClick={() => downloadPdf(row.project_id, `${Apiurl}user/product-log`)}
                              className="hover:bg-red-50 rounded-sm transition-all"
                            >
                              <AutoAwesomeMotionIcon className="text-orange-600" style={{ fontSize: '20px' }} />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </TableCell>
                      <TableCell>
                        {pdfloading && row.project_id === pdfId ? (
                          <Lottie
                            animationData={animationData}
                            loop
                            autoplay
                            style={{ height: "30px", width: "30px" }}
                          />
                        ) : (
                          <IconButton
                            color="error"
                            onClick={() => {
                              downloadpdf(row.project_id);
                              localStorage.setItem("projectId", row.project_id);
                            }}
                          >
                            <PreviewIcon className="cursor-pointer text-blue-600 scale-125 hover:scale-150" />
                          </IconButton>
                        )}
                      </TableCell>
                      <TableCell>
                        <div className="flex items-center gap-2">
                          <span>{row.project_id}</span>
                          {row.transferred_user_name && (
                            <span className="relative flex h-5 w-5">
                              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 "></span>
                              <span className="relative inline-flex items-center justify-center rounded-full h-5 w-5 bg-orange-600 text-white text-[10px] font-bold">
                                T
                              </span>
                            </span>
                          )}
                        </div>
                      </TableCell>

                      {/* Client ID */}
                      <TableCell>{row.client_id}</TableCell>

                      {/* Client Name */}
                      <TableCell>{row.client_name}</TableCell>
                      <TableCell>{row.currencies}</TableCell>

                      {/* WhatsApp */}
                      <TableCell>
                        {row.phone ? (
                          <a
                            href={`https://web.whatsapp.com/send?phone=${row.phone}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={async () => {
                              try {
                                const token = localStorage.getItem("u_token");

                                await axios.post(
                                  `${Apiurl}project/download-status/${row.project_id}`,
                                  { whatsCount: 1 },
                                  {
                                    headers: {
                                      Authorization: `Bearer ${token}`,
                                    },
                                  }
                                );
                              } catch (statusError) {
                                console.error("Failed to update download status", statusError);
                              }
                            }}
                          >
                            <WhatsAppIcon className="cursor-pointer text-green-600 scale-125 hover:scale-150" />
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                      {/* <TableCell>{row.user_channel || "N/A"}</TableCell> */}
                      <TableCell>
                        {(() => {
                          if (!row?.user_id) {
                            return (
                              <Typography variant="caption" sx={{ color: "#757574" }}>
                                'N/A'
                              </Typography>
                            );
                          }

                          if (row.user_id == userId) {
                            return "By You";
                          }

                          const user = userOption?.find((u) => u.id == row.user_id);

                          if (!user) {
                            return (
                              <Typography variant="caption" sx={{ color: "#757574" }}>
                                Unknown User
                              </Typography>
                            );
                          }
                          return `${user.name} ${user.last_name || ""}`.trim();
                        })()}
                      </TableCell>
                      <TableCell>
                        {(() => {
                          if (!row?.updated_user_id) {
                            return (
                              <Typography variant="caption" sx={{ color: "#757574" }}>
                                No updates
                              </Typography>
                            );
                          }

                          if (row.updated_user_id == userId) {
                            return "By You";
                          }

                          const user = userOption?.find((u) => u.id == row.updated_user_id);

                          if (!user) {
                            return (
                              <Typography variant="caption" sx={{ color: "#94a3b8" }}>
                                Unknown User
                              </Typography>
                            );
                          }

                          return `${user.name} ${user.last_name || ""}`.trim();
                        })()}
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          {(() => {
                            if (!row?.shared) {
                              return (
                                <Typography variant="caption" sx={{ color: "#757574" }}>
                                  Not Shared
                                </Typography>
                              );
                            }
                            const sharedArray = row.shared.split(",");
                            const visibleUsers = row.user_id == userId
                              ? sharedArray
                              : sharedArray.filter(id => id.trim() == userId);

                            return (
                              <Box sx={{ display: "flex", alignItems: "center" }}>
                                {visibleUsers.slice(0, 3).map((uId, i) => {
                                  const sharedUser = userOpt?.find((u) => String(u.value) == uId.trim());
                                  const label = sharedUser ? sharedUser.label : "Unknown User";

                                  return (
                                    <Tooltip key={uId} title={label} arrow placement="top">
                                      <Avatar
                                        sx={{
                                          width: 28,
                                          height: 28,
                                          fontSize: "0.75rem",
                                          fontWeight: 600,
                                          bgcolor: "#04121f",
                                          color: "white",
                                          border: "2px solid white",
                                          marginLeft: i == 0 ? 0 : "-10px",
                                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                          cursor: "default",
                                        }}
                                      >
                                        {label.charAt(0).toUpperCase()}
                                      </Avatar>
                                    </Tooltip>
                                  );
                                })}
                                {row.user_id == userId && visibleUsers.length > 3 && (
                                  <Tooltip
                                    title={visibleUsers
                                      .slice(3)
                                      .map((id) => {
                                        const u = userOpt?.find((opt) => String(opt.value) == id.trim());
                                        return u ? u.label : "Unknown";
                                      })
                                      .join(", ")}
                                    arrow
                                    placement="top"
                                  >
                                    <Avatar
                                      sx={{
                                        width: 28,
                                        height: 28,
                                        fontSize: "0.7rem",
                                        bgcolor: "#e2e8f0",
                                        color: "#475569",
                                        border: "2px solid white",
                                        marginLeft: "-10px",
                                        fontWeight: 700,
                                        cursor: "default",
                                      }}
                                    >
                                      +{visibleUsers.length - 3}
                                    </Avatar>
                                  </Tooltip>
                                )}
                              </Box>
                            );
                          })()}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="caption" sx={{ color: "#757574" }}>
                          {row.transferred_user_name ? row.transferred_user_name : "Not Transferred"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {new Date(row.created_at).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </TableCell>
                      {/* <TableCell>{row.designation}</TableCell> */}
                      <TableCell>
                        {new Date(row.created_at).getTime() ===
                          new Date(row.updated_at).getTime()
                          ? "No updates"
                          : new Date(row.updated_at).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                      </TableCell>
                      <TableCell
                        style={{
                          color: (() => {
                            const validDate = new Date(row.valid_date);
                            const currentDate = new Date();
                            currentDate.setHours(0, 0, 0, 0);
                            validDate.setHours(0, 0, 0, 0);

                            if (
                              validDate.toDateString() ===
                              currentDate.toDateString()
                            ) {
                              return "green";
                            } else if (validDate < currentDate) {
                              return "red";
                            } else if (
                              validDate.toDateString() ===
                              new Date(
                                currentDate.setDate(currentDate.getDate() + 1)
                              ).toDateString()
                            ) {
                              return "black";
                            }
                            return "black";
                          })(),
                        }}
                      >
                        {new Date(row.valid_date).toLocaleDateString("en-GB")}
                      </TableCell>
                      <TableCell>
                        <FormControl fullWidth>
                          <MuiSelect
                            labelId="status-label"
                            id="status-select"
                            value={row.status}
                            label="Status"
                            onChange={(e) => handleChange(row.id, e.target.value)}
                          >
                            <MenuItem value="enquiry">Enquiry</MenuItem>
                            <MenuItem value="pipeline">Pipeline</MenuItem>
                            <MenuItem value="conversion">Conversion</MenuItem>
                            <MenuItem value="lost">Lost</MenuItem>
                          </MuiSelect>
                        </FormControl>
                      </TableCell>
                      {/* Action */}
                      <TableCell>
                        <span className="flex gap-6">
                          {/* <Button
                          variant="contained"
                          disabled={loadingId !== null}
                          onClick={() => editProject(row,'/user/create-quote')}
                          style={{
                            textTransform: "none",
                            backgroundColor: loadingId === row.id ? "#004d40" : "#0f766e",
                            minWidth: "100px",
                            height: "32px",
                            fontSize: "0.85rem",
                            fontWeight: "500",
                            borderRadius: "6px",
                            boxShadow: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            transition: "all 0.2s ease-in-out",
                          }}
                        >
                          {loadingId === row.id ? (
                            <CircularProgress size={14} style={{ color: "white" }} />
                          ) : (
                            <>
                              <EditIcon style={{ fontSize: "10px" }} />
                              <span>Edit</span>
                            </>
                          )}
                        </Button> */}
                          <Button
                            variant="contained"
                            disabled={loadingId !== null}
                            onClick={() => editProject(row, '/user/create-quote-fx')}
                            style={{
                              textTransform: "none",
                              backgroundColor: loadingId === row.id ? "#004d40" : "#0f766e",
                              minWidth: "120px",
                              height: "32px",
                              fontSize: "0.85rem",
                              fontWeight: "500",
                              borderRadius: "6px",
                              boxShadow: "none",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              transition: "all 0.2s ease-in-out",
                            }}
                          >
                            {loadingId === row.id ? (
                              <CircularProgress size={14} style={{ color: "white" }} />
                            ) : (
                              <>
                                <EditIcon style={{ fontSize: "10px" }} />
                                <span>Edit</span>
                              </>
                            )}
                          </Button>
                        </span>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 500, counts]}
            component="div"
            count={counts || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            className="bg-white/40 border-t border-white/50 text-[#1e293b]"
          />
        </div>
      )}

      <div style={{ display: showComponent ? "block" : "none" }}>
        <DownloadSummary
          project={projectId}
          sendData={handleDataFromDownloadSummary}
        />
      </div>
    </>
  );
};

export default Summary;
